import React from "react";
import ContractRoutes from "components/routes/ContractRoutes";

const ContractHome = () => {
  return <ContractRoutes />;
};

export default ContractHome;
